import { Box } from '@chakra-ui/react';

import { FCWithChildren } from 'common/types';

const StickyFooter: FCWithChildren = ({ children }) => {
  return (
    <Box
      bgColor="white"
      bottom="0"
      display="flex"
      justifyContent="flex-end"
      padding="space-32"
      position="sticky"
      zIndex="sticky"
    >
      {children}
    </Box>
  );
};

export default StickyFooter;
